import React from 'react';
import Bang1 from '../../assets/images/ico_bang1.png';
import Bang2 from '../../assets/images/ico_bang2.png';
import Bang3 from '../../assets/images/ico_bang3.png';
import Bang4 from '../../assets/images/ico_bang4.png';
import Bang5 from '../../assets/images/ico_bang5.png';
import { TrainsType } from '../../apis/Transits.api';

interface props {
  trainData: TrainsType[];
  setDetailDisp: React.Dispatch<React.SetStateAction<TrainsType[] | undefined>>;
}

export const InaccurateTrain: React.FC<props> = (props) => {
  const data = props.trainData;
  const setDetailDisp = props.setDetailDisp;
  const TrainColor = (course: number) => {
    switch (course) {
      case 1:
        return Bang1;
      case 2:
        return Bang2;
      case 3:
        return Bang3;
      case 4:
        return Bang4;
      case 5:
        return Bang5;
    }
  };

  return (
    <g onClick={() => setDetailDisp(data)} cursor='pointer'>
      <image
        key={`${'inaccurateTrain' + data[0].id}`}
        x={data[0].x - 15}
        y={data[0].y - 86}
        xlinkHref={TrainColor(data[0].course)}
      ></image>
    </g>
  );
};
